import {useState} from "react";

export const useDeferredModalClose = (onClosed: () => void) => {
    const [isCloseRequested, setIsCloseRequested] = useState(false);

    const requestClose = () => {
        setIsCloseRequested(true);
    };

    const handleAfterClose = () => {
        if (isCloseRequested) {
            onClosed();
        }
    };

    return {isOpen: !isCloseRequested, requestClose, handleAfterClose};
};
import {useState} from "react";

export const useDeferredModalClose = (onClosed: () => void) => {
    const [isCloseRequested, setIsCloseRequested] = useState(false);

    const requestClose = () => {
        setIsCloseRequested(true);
    };

    const handleAfterClose = () => {
        if (isCloseRequested) {
            onClosed();
        }
    };

    return {isOpen: !isCloseRequested, requestClose, handleAfterClose};
};
